module.exports = __webpack_public_path__ + "img/map2.e3d7025d.png";